import type { ApiPayor } from '../../services/payorConfigurationService'
import {
  matchPayorForPrimaryPayorName,
  resolvePayorApiId,
} from '../../services/payorConfigurationService'
import type { CreatePriorAuthorizationPayload } from '../../services/priorAuthorizationService'
import type { PatientRecord } from '../../data/patientData'
import { patientPriorAuthFieldPatch } from '../../data/patientData'

export function buildPatientSelectPatch(
  record: PatientRecord,
  payors: ApiPayor[]
): Partial<CreatePriorAuthorizationPayload> {
  const fields = patientPriorAuthFieldPatch(record)
  const matchedPayor = fields.payor_name_hint
    ? matchPayorForPrimaryPayorName(fields.payor_name_hint, payors)
    : undefined

  return {
    patient_id: fields.patient_id,
    subscriber_id: fields.subscriber_id,
    provider_name: fields.provider_name,
    provider_npi: fields.provider_npi,
    payor_id: matchedPayor ? resolvePayorApiId(matchedPayor) : '',
  }
}

export function resolvePayorIdFromHint(
  payorHint: string,
  payors: ApiPayor[]
): string {
  const trimmed = payorHint.trim()
  if (!trimmed) return ''

  const byId = payors.find((payor) => resolvePayorApiId(payor) === trimmed)
  if (byId) return trimmed

  const matched = matchPayorForPrimaryPayorName(trimmed, payors)
  return matched ? resolvePayorApiId(matched) : trimmed
}
